var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-center mt-6"},[_c('img',{staticClass:"tfb-page-divider mx-auto",attrs:{"src":_vm.imageRootPath + 'divider-star.png',"alt":"Page Divider"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }